// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconFile: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="currentColor">
            <path
                d="M84,1133.25 L84,1135.75 L86.5,1135.75 L84,1133.25 Z M83.375,1135.75 L83.375,1133.25 L79.9375,1133.25 C79.4197267,1133.25 79,1133.66973 79,1134.1875 L79,1142.3125 C79,1142.83008 79.4197267,1143.25 79.9375,1143.25 L85.5625,1143.25 C86.0802736,1143.25 86.5,1142.83027 86.5,1142.3125 L86.5,1136.375 L84.017578,1136.375 C83.6542969,1136.375 83.375,1136.0957 83.375,1135.75 Z"
                transform="translate(-79 -1133)"
            />
        </svg>
    );
};

export default React.memo(IconFile);
